import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LaunchContext = createContext(null);

export const useLaunch = () => {
  const ctx = useContext(LaunchContext);
  if (!ctx) throw new Error('useLaunch must be used within a LaunchProvider');
  return ctx;
};

const APP_STORE_URL = 'https://apps.apple.com/us/app/logicar/id6743690788';
const RELEASE_ISO = '2025-10-30T00:00:00';

export const LaunchProvider = ({ children }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000 * 30);
    return () => clearInterval(interval);
  }, []);

  const isLaunched = useMemo(() => {
    const releaseTs = new Date(RELEASE_ISO).getTime();
    return now >= releaseTs;
  }, [now]);

  const value = useMemo(
    () => ({ isLaunched, appStoreUrl: APP_STORE_URL, releaseIso: RELEASE_ISO }),
    [isLaunched]
  );

  return (
    <LaunchContext.Provider value={value}>
      {children}
    </LaunchContext.Provider>
  );
};

export default LaunchContext;

